<template>
   <Modal
      :dialog.sync="dialog"
      :contentClass="'esh-theme adminModal'"
      :width="500"
      title="Поиск пользователя"
    >
    <template #body>
      <v-card
        outlined
        class="pa-6"
      >
        <v-row no-gutters>
          <v-col>
            <v-row>
              <Select
                v-model="district"
                :items="districts"
                item-text="short_name"
                item-value="id"
                label="Муниципалитет:"
                class="fs-admin-complex-autocomplete"
                @change="loadSchools"
                blank
              />
            </v-row>
            <v-row>
              <Select
                v-if="district !== null"
                v-model="school"
                label="Школа:"
                :items="schools"
                item-text="short_name"
                item-value="id"
                class="fs-admin-complex-autocomplete"
                @change="loadClasses"
                blank
              />
            </v-row>
            <v-row>
              <Select
                v-if="school !== null"
                v-model="role"
                label="Выберите тип допуска"
                :items="roles"
                item-value="id"
                item-text="name"
                @change="changeFindUserRole"
                blank
              />
            </v-row>
            <v-row>
              <Select
                v-if="role === PUPIL_ROLE_DATA.id"
                label="Выберите класс/должность"
                v-model="school_class"
                :items="school_classes"
                item-value="id"
                item-text="name"
                @change="loadUsers"
                blank
              />
            </v-row>
            <v-row>
              <Select
                v-if="role !== GUEST_ROLE && role !== null"
                v-model="user"
                :items="users"
                label="ФИО"
                item-value="id"
                item-text="name"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </template>
    <template #actions>
      <v-row justify="end" no-gutters>
        <v-btn
          :disabled="role !== GUEST_ROLE && user === null"
          @click="foundUser"
        >
          Дальше
        </v-btn>
      </v-row>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import { Modal, Select } from '@/components/common'
import {
  GET_SUGGESTION_CLASSES,
  GET_SUGGESTION_MUNICIPALITIES,
  GET_SUGGESTION_SCHOOLS,
  GET_SUGGESTION_USERS
} from '@/requests/superadmin'

const GUEST_ROLE = -1
const GUEST_ROLE_DATA = { name: 'Гостевая', id: GUEST_ROLE }
const initState = {
  role: null,
  district: null,
  school: null,
  school_class: null,
  user: null,
  users: [],
  districts: [],
  schools: [],
  school_classes: []
}

export default {
  name: 'CardFindUserModalSuperAdmin',
  components: {
    Modal,
    Select
  },
  props: {
    show: {
      props: Boolean,
      default: false
    }
  },
  data() {
    return {
      GUEST_ROLE,
      ...initState
    }
  },
  mounted() {
    this.loadDistricts()
  },
  computed: {
    ...mapState({
      cardRoles: state => state.common.constants.card_roles,
      PUPIL_ROLE_DATA: state =>
        state.common.constants.card_roles.find(r => r.alias === 'PUPIL')
    }),
    roles() {
      return [...this.cardRoles, GUEST_ROLE_DATA]
    },
    dialog: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },
  watch: {
    show: function(state) {
      if (state) {
        for (let [key, value] of Object.entries(initState)) {
          if (key !== 'districts') {
            this[key] = value
          }
        }
      }
    }
  },
  methods: {
    foundUser() {
      const user = this.users.find(u => u.id === this.user)
      this.$emit('user', {
        ...user,
        unit: this.school
      })
    },
    changeFindUserRole() {
      this.user = null
      this.school_class = null

      if (this.role !== GUEST_ROLE) {
        this.loadUsers()
      }
    },
    async loadDistricts() {
      try {
        let { data } = await GET_SUGGESTION_MUNICIPALITIES()
        this.districts = data.results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить муниципалитеты'
        })
      }
    },
    async loadSchools() {
      this.school = null
      this.schools = []
      if (this.district === null) return

      try {
        const { data: { results } } = await GET_SUGGESTION_SCHOOLS({
          district: this.district
        })

        this.schools = results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить школы'
        })
      }
    },
    async loadClasses() {
      this.school_class = null
      this.school_classes = []
      if (this.school === null) return

      try {
        let { data: { results }} = await GET_SUGGESTION_CLASSES({
          unit: this.school
        })

        this.school_classes = results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о классах'
        })
      }
    },
    async loadUsers() {
      try {
        let { data } = await GET_SUGGESTION_USERS({
          school_class: this.school_class,
          role: this.role,
          unit: this.school
        })

        this.users = data.results.map(u => ({
          ...u,
          full_name: u.name
        }))
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию об учениках и сотрудниках'
        })
      }
    }
  }
}
</script>